<template>
  <b-modal
      modal-class="footer-dialog"
      data-test-path="dialog-mail-browser"
      id="bv-modal-mail-browser"
      @hide="onHide"
      @ok="onOk"
      size="xl"
      ref="modal"
      data-backdrop="static" data-keyboard="false"
      :title="$tr('mailBrowserDialog.choose.email','Choose email from address book')"
  >
    <b-container class="px-0 mx-0" fluid="true">
      <b-row>
        <b-col style="height: 500px">
          <DataGrid2
              style="height: 100%"
              ref="grid"
              name="mailBrowserDialog"
              v-model="selectedEmails"
              :selectedIndex.sync="selectedIndex"
              :items="list"
              :columns="fields"
              :headerShowReload="true"
              @reload="refresh"
              select-mode="range"
              :details-enable="false"
          >
          </DataGrid2>
        </b-col>
      </b-row>
    </b-container>
    <template #modal-footer="{close}">
      <FooterNavbar data-test-path="mail-browser-footer" class="w-100">
        <CloseButton @close="cancel"></CloseButton>
        <FooterButton type="Ok" @ok="onOk" :disabled="!selectedEmails.length"></FooterButton>
      </FooterNavbar>
    </template>
  </b-modal>
</template>

<script>
import FooterNavbar from "@/components/navbar/FooterNavbar";
import VBox from "@/components/VBox";
import DataGrid2 from "@/components/datagrid/DataGrid2";
import Perms from "@/server/Perms";
import PermissionsSet from "@/server/PermissionsSet";
import FooterButton from "@/components/navbar/FooterButton";
import CloseButton from "@/components/navbar/CloseButton";
import Suppliers from "@/server/com/silkplm/model/plm/Suppliers";
import Representative from "@/server/com/silkplm/model/plm/Representative";

export default {
  name: "MailBrowserDialog",
  components: {FooterButton, DataGrid2, VBox, FooterNavbar, CloseButton},
  created() {
  },
  async beforeMount() {
  },
  mounted() {
    /** @type {DataGrid2|Vue} */
    this.grid = this.$refs["grid"];
  },
  methods: {
    async onHide(ev) {
      if (this.resolve != null) {
        this.resolve([]);
        this.resolve = null;
      }
    },
    async onOk() {
      if (this.resolve != null && this.selectedEmails != null) {
        for (let i = 0; i < this.selectedEmails.length; i++) {
          this.result.push(this.selectedEmails[i].email);
        }
        this.resolve(this.result);
        this.resolve = null;
      }
      this.$refs.modal.hide();
    },
    async cancel() {
      this.$refs.modal.hide();
    },
    async refresh() {
      this.listSuppliers = [];
      this.listRepresentative = [];

      try {
        this.listSuppliers = await Suppliers.list();
        this.listRepresentative = await Representative.list();

        let processedSuppliers = this.listSuppliers
            .filter(item => item.companyFullName && (item.email || item.primaryEmail || (item.otherEmailAddresses && item.otherEmailAddresses.length > 0)))
            .map(item => {
              return {
                company: item.companyFullName,
                email: item.email || item.primaryEmail || (item.otherEmailAddresses ? item.otherEmailAddresses[0] : $tr("emptyEmail", "Empty email"))
              };
            });
        let processedRepresentatives = this.listRepresentative
            .filter(item => item.name && item.surname && item.email)
            .map(item => {
              return {
                company: `${item.name} ${item.surname}`,
                email: item.email
              };
            });

        this.list = [...processedSuppliers, ...processedRepresentatives];
        this.selectedEmails = this.list;

      } catch (error) {
        console.error("Failed to refresh list:", error);
      }
    },
    reset() {
      this.result = [];
      this.resolve = null;
    },
  },
  data() {
    return {
      list: [],
      listSuppliers: [],
      listRepresentative: [],
      fields: [
        {name: "Company name", sortable: true, size: 510, prop: "company"},
        {name: "Address Email", sortable: true, size: 210, prop: "email"},
      ],
      resolve: null,
      result: [],
      selectedEmails: [],
      selectedIndex: null,
    };
  },
};
</script>
